webpackJsonp([198136819019171],{

/***/ 1105:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _medicare = __webpack_require__(49);
	
	var _globalStyles = __webpack_require__(4);
	
	var _resourceCard = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MedicareForGPsPage = function MedicareForGPsPage() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      _reactHelmet.Helmet,
	      { title: 'Medicare for GPs' },
	      _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	      _react2.default.createElement('meta', { property: 'og:title', content: 'Medicare for GPs' }),
	      _react2.default.createElement('meta', { name: 'description', content: 'Medicare for GPs' }),
	      _react2.default.createElement('meta', { property: 'og:description', content: 'Medicare for GPs' })
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)(_globalStyles.purple) },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle },
	        _react2.default.createElement(
	          'h1',
	          { className: _medicare.titleStyle, style: { color: '#FFF', margin: '0 0 150px' } },
	          'Medicare for GPs'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: (0, _globalStyles.contentSection)('none'), style: { marginTop: '-200px' } },
	      _react2.default.createElement(
	        'div',
	        { className: _medicare.innerWrapperStyle, style: { display: 'flex' } },
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/eating-disorder-care-plan',
	            audiences: [],
	            title: 'Eating Disorder Care Plan',
	            body: 'The medical practitioner can use this template to complete the Eating Disorder Care Plan'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/eating-disorder-examination-questionnaire-ede-q',
	            audiences: [],
	            title: 'EDE-Q',
	            body: 'This is a self-report version of the Eating Disorder Examination tool which assesses eating disorder pathology.'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/resource-library/gp-care-plan-review-template',
	            audiences: [],
	            title: 'GP Care Plan Review Template',
	            body: 'The medical practitioner can use this template to complete the Eating Disorder Care Plan Review at session 10, 20 and 30.'
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _medicare.resourceWrapper },
	          _react2.default.createElement(_resourceCard.ResourceCard, {
	            background: null,
	            to: '/medicare/for-health-professionals',
	            audiences: [],
	            title: 'For Health Professionals',
	            body: 'For more details, see our Medicare for Health Professionals page'
	          })
	        )
	      )
	    )
	  );
	};
	
	exports.default = MedicareForGPsPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-medicare-for-gps-index-js-8a199d1c586b4e9f8f56.js